//aqui ponemos los datos que apareceran en cada una de las secciones
// es una forma de reutilizar codigo

export const homeObjectOne={
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDescription: true,
    topLine: 'Premium Bank',
    headLine: 'Unlimited Trasactions with zero fees',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Necessitatibus praesentium laboriosam sunt nulla eveniet animi corrupti labore corporis nemo facere optio sequi molestiae voluptatum quo, fugit quae eligendi deleniti enim itaque iste magni tempore? Aliquam blanditiis ratione ducimus commodi error.',
    buttonLabel: 'Get started',
    imgStart: true,
    img: require('../../images/img3.svg').default,
    alt: 'Car',
    dark: true,
    primary: true,
    darkText: false
    
};

export const homeObject2={
    id: 'discover',
    lightBg: true,
    lightText: false,
    lightTextDescription: false,
    topLine: "Lorem, ipsum adipisicing elit. Aut, quibusdam?",
    headLine: "Lorem ipsum dolor sit amet, consectetur adipisicing elit",
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Necessitatibus praesentium laboriosam sunt nulla eveniet animi corrupti labore corporis nemo facere optio sequi molestiae voluptatum quo, fugit quae eligendi deleniti enim itaque iste magni tempore? Aliquam blanditiis ratione ducimus commodi error.',
    buttonLabel: 'Get started',
    imgStart: true,
    img: require('../../images/img2.svg').default,
    alt: 'img2',
    dark: false,
    primary: true,
    darkText: true
    
};

export const homeObject3={
    id: 'signup',
    lightBg: true,
    lightText: false,
    lightTextDescription: false,
    topLine: 'Premium Bank',
    headLine: 'Unlimited Trasactions with zero fees',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Necessitatibus praesentium laboriosam sunt nulla eveniet animi corrupti labore corporis nemo facere optio sequi molestiae voluptatum quo, fugit quae eligendi deleniti enim itaque iste magni tempore? Aliquam blanditiis ratione ducimus commodi error.',
    buttonLabel: 'Start now',
    imgStart: true,
    img: require('../../images/img4.svg').default,
    alt: 'img4',
    dark: false,
    primary: false,
    darkText: true
    
};
